import React from 'react'
import { Expansible } from 'components/Expansible'

import { Alert } from '@mui/material'
import Container from './styles'
import FinancialPendingsTable from '../FinancialPendingsTable'
import BuildResumeBoard from './BuildResumeBoard'

const splitBases = (ocurrences) => {
  const base1 = []
  const base2 = []
  const base3 = []
  ocurrences?.forEach((ocurrencie) => {
    switch (ocurrencie.informant) {
      case 'SERASA':
        base1.push(ocurrencie)
        break
      case 'SCPC':
        base3.push(ocurrencie)
        break
      default:
        base2.push(ocurrencie)
        break
    }
  })
  return { serasa: base1, spc: base3, others: base2 }
}

function BuildFinancialPendings(props) {
  const { financialPendingsData } = props

  
  const financialPendingsDataDetails = financialPendingsData?.details?.data



  if (financialPendingsDataDetails == null) {
    return <p>{financialPendingsData.reason || 'Informações indisponíveis'}</p>
  }

  const getCreditRestrictionsMsgInfo = () => {
    const infos = financialPendingsDataDetails?.msg_infos || []
    return infos[0]?.msg
  }

  const getCreditRestrictionsMsgError = () => {
    const infos = financialPendingsDataDetails?.msg_errors || []
    return infos[0]?.msg
  }

  const msgInfo = getCreditRestrictionsMsgInfo()
  const msgError = getCreditRestrictionsMsgError()
  const creditRestrictions = financialPendingsDataDetails?.credit_restrictions_data?.financial_pending
  const pendingsList = creditRestrictions?.occurrences
  const quantity = creditRestrictions?.quantity_occurrences
  const totalValue = creditRestrictions?.total_value
  const totalValueWithoutDuplicates = creditRestrictions?.total_value_without_duplicates

  const bases = splitBases(pendingsList)

  return (
    <div style={{ margin: '15px 0' }}>
      <div style={{ gap: 10, display: 'flex', flexDirection: 'column', width: '100%' }}>
        {msgInfo && (
          <Alert color="warning" severity="error">
            {msgInfo}
          </Alert>
        )}
        {msgError && (
          <Alert color="warning" severity="error">
            {msgError}
          </Alert>
        )}
        {(!msgError && !msgInfo && financialPendingsDataDetails?.consists === false) && (
          <Alert color="primary" severity="success">
            Nenhuma informação de pendência financeira encontrada.
          </Alert>
        )}
      </div>
      <Container>
        {creditRestrictions && (
          <BuildResumeBoard
            boardData={bases}
            quantity={quantity}
            totalAmount={totalValueWithoutDuplicates || totalValue}
          />
        )}

        {pendingsList?.length ? (
          <Expansible title="Lista de Ocorrências" open={false}>
            <FinancialPendingsTable
              pendings={pendingsList}
              totalValue={totalValue}
              totalValueWithoutDuplicates={totalValueWithoutDuplicates}
            />
          </Expansible>
        ) : null}
      </Container>
    </div>
  )
}

export default BuildFinancialPendings
